var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { ListDiffSpec, } from '../../parsing/UiTypesSpec';
import { applyDiff, convertToListDiff, EMPTY_DIFF, } from '../../utils/ListDiffUtils';
import { UISelect } from './UISelect';
export var EnumInputComponent = function (_a) {
    var _b, _c, _d;
    var input = _a.input, config = _a.config, theme = _a.theme, onChange = _a.onChange, readonly = _a.readonly;
    var configuredDiff = ListDiffSpec.optional()
        .default(EMPTY_DIFF)
        .parse((_b = config === null || config === void 0 ? void 0 : config.inputConfigs) === null || _b === void 0 ? void 0 : _b[input.macroName]);
    var themeDiff = (_d = (_c = theme === null || theme === void 0 ? void 0 : theme.config) === null || _c === void 0 ? void 0 : _c.inputConfigs) === null || _d === void 0 ? void 0 : _d[input.macroName];
    var currentSetting = applyDiff(input.default, [themeDiff, configuredDiff]);
    var options = input.enum.map(function (enumValue) {
        if (typeof enumValue === 'string') {
            return {
                label: enumValue,
                value: enumValue,
            };
        }
        return enumValue;
    });
    var selectedOptions = Array.isArray(currentSetting)
        ? currentSetting
            .filter(function (value) { return typeof value === 'string'; })
            .map(function (value) {
            var found = options.find(function (o) { return o.value === value; });
            if (found) {
                return found;
            }
            return {
                label: value,
                value: value,
            };
        })
        : [];
    return (_jsxs("div", { children: [_jsx("div", __assign({ style: { display: 'flex', gap: 2, alignItems: 'center' } }, { children: _jsx(Typography, __assign({ variant: "h6", color: "primary" }, { children: input.label })) })), _jsx(UISelect, { disabled: readonly, options: options, value: selectedOptions, onChange: function (newValue) {
                    onChange(convertToListDiff(newValue
                        ? newValue.map(function (option) { return option.value; })
                        : [], applyDiff(input.default, [themeDiff])));
                }, multiple: true, label: "Select options" })] }));
};
